<template>
  <div class="update-password">
    <!-- 头部 -->
    <headerTop :type="1" title="修改登录密码"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="form-area">
        <van-cell-group>
          <van-field
            v-model="oldPassword"
            type="password"
            center
            clearable
            label="原密码"
            placeholder="请输入您的原密码"
            maxlength="16"
          ></van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="newPassword"
            type="password"
            center
            clearable
            label="新密码"
            placeholder="6-16位数字或字母"
            maxlength="16"
          ></van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="confirmPassword"
            type="password"
            center
            clearable
            label="确认密码"
            placeholder="再次输入新密码"
            maxlength="16"
          ></van-field>
        </van-cell-group>
      </div>
      <div class="btn-box">
        <loading-btn btnClass="btn" v-preventReClick @click="handleSubmit">保存</loading-btn>
      </div>
      <div class="row">
        <span></span>
        <span @click="toForget">忘记密码？</span>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import loadingBtn from "@/components/common/loadingBtn";
import validationMixin from "@/mixins/validationMixin";
import userApi from "@/api/userApi";
import { removeUserId, removeToken, AESEncrypted } from "@/libs/util";

export default {
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
  },
  mixins: [validationMixin],
  components: {
    headerTop,
    loadingBtn
  },
  methods: {
    handleSubmit() {
      let validations = [
        {
          value: this.oldPassword,
          method: "required",
          message: "请输入您的原密码"
        },
        {
          value: this.oldPassword,
          method: "rangelength",
          param: [6, 16],
          message: "原密码长度错误（6-16位数字、字母）"
        },
        {
          value: this.newPassword,
          method: "required",
          message: "请输入您的新密码"
        },
        {
          value: this.newPassword,
          method: "rangelength",
          param: [6, 16],
          message: "新密码长度错误（6-16位数字、字母）"
        },
        {
          value: this.confirmPassword,
          method: "required",
          message: "请输入您的确认密码"
        },
        {
          value: this.confirmPassword,
          method: "rangelength",
          param: [6, 16],
          message: "确认密码长度错误（6-16位数字、字母）"
        }
      ];

      if (this.check(validations)) {
        if (!/^[a-z0-9]{6,16}$/.test(this.oldPassword)) {
          this.$toast("原密码格式错误（6-16位数字、字母）");
          return;
        }
        if (!/^[a-z0-9]{6,16}$/.test(this.newPassword)) {
          this.$toast("新密码格式错误（6-16位数字、字母）");
          return;
        }
        if (!/^[a-z0-9]{6,16}$/.test(this.confirmPassword)) {
          this.$toast("确认密码格式错误（6-16位数字、字母）");
          return;
        }
        if (this.newPassword !== this.confirmPassword) {
          this.$toast("确认密码与新密码不一致，请重新输入");
          return;
        }
        const params = {
          old_password: AESEncrypted(this.oldPassword),
          new_password: AESEncrypted(this.newPassword),
          new_password_retype: AESEncrypted(this.confirmPassword),
          user_id: this.userInfo.user_id
        };
        userApi.updatePassword(params).then(res => {
          this.$toast("修改登录密码成功!请重新登录...");
          setTimeout(() => {
            userApi.logout().then(res => {
              removeUserId();
              removeToken();
              window.location.href = window.location.origin + "/login";
            });
          }, 2000);
        });
      }
    },
    toForget() {
      userApi.logout().then(res => {
        removeUserId();
        removeToken();
        window.location.href = window.location.origin + "/login/forget";
      });
    }
  }
};
</script>

<style lang="less">
.update-password {
  background: #ffffff;
  height: 100vh;

  .content {
    padding: 0px 20px;

    .note {
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
    }

    .text {
      font-size: 16px;
      color: #333333;
      margin-bottom: 50px;
    }

    .form-area {
      position: relative;

      .van-cell {
        .van-field__label {
          max-width: 28vw;
        }

        .van-field__body input {
          text-align: right;
        }
      }
    }
  }

  .btn-box {
    margin-top: 40px;
    .btn {
      width: 100%;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #8a3e2f;
      font-size: 17px;
      color: #ffffff;
      margin: 20px 0 10px;
    }
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 12px;
      color: #666666;
    }
  }
}
</style>
